import { render, staticRenderFns } from "./InstitutionsIndex.vue?vue&type=template&id=73e2fa22"
import script from "./InstitutionsIndex.vue?vue&type=script&lang=js"
export * from "./InstitutionsIndex.vue?vue&type=script&lang=js"
import style0 from "./InstitutionsIndex.vue?vue&type=style&index=0&id=73e2fa22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports